"use strict";Object.defineProperty(exports,"__esModule",{value:!0}),exports.maybe=function(e){try{return e()}catch(e){}};
//# sourceMappingURL=maybe.js.map
